module.exports = __webpack_public_path__ + "assets/44a6d19389e49512fa9d954f4cf0ad6d.svg";